export class Funcion {
    constructor(fecha, hora, disponibles) {
      this.fecha = fecha;
      this.hora = hora;
      this.disponibles = disponibles;
    }
  }